import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBJraqTaqhmU_RmJX83uR5gnyE5rWKFI9w",
  authDomain: "gaziderby-a23d6.firebaseapp.com",
  projectId: "gaziderby-a23d6",
  storageBucket: "gaziderby-a23d6.firebasestorage.app",
  messagingSenderId: "808850101473",
  appId: "1:808850101473:web:c885c513f4f8a3762353a0",
  measurementId: "G-064EFHCLS8"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.warn("Firebase Analytics could not be initialized:", error);
}

export function logAnalyticsEvent(eventName, eventParams = {}) {
  if (analytics) {
    try {
      logEvent(analytics, eventName, eventParams);
      console.log(`[Analytics Log] Event: ${eventName}`, eventParams);
    } catch (e) {
      console.error(`[Analytics Error] Failed to log event ${eventName}:`, e);
    }
  } else {
    console.log(`[Analytics Dummy Log] Event: ${eventName}`, eventParams);
  }
}

